import React from "react";

function About() {
  return (
    <>
      <section className="tab_contengt_holder">
        <p className="tab_text">
          Rooted in a storied 115-year legacy, Mittal Group stands as a
          testament to timeless craftsmanship & innovation. Under its
          specialised wing Mittal Craftworks, the group carves a niche with the
          Copperkraft brand, offering an exquisite selection of Copper-ware.
          Each Copperkraft piece embodies the fusion of traditional techniques
          and modern elegance, reflecting our unwavering commitment to quality
          and the artistry of our heritage.
        </p>
      </section>
    </>
  );
}

export default About;
